import { SVGProps, Ref, forwardRef } from 'react';

export const ArchiveboxFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M0 2.15C0 3.594.208 3.8 1.667 3.8h12.666C15.792 3.8 16 3.594 16 2.15S15.792.5 14.333.5H1.667C.208.5 0 .706 0 2.15"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.333 10.837V5.2h13.33v5.636h-.002c-.05 3.492-1.296 4.664-4.886 4.664H6.221c-3.59 0-4.836-1.172-4.886-4.664zm4.332-2.74h4.666v-1.4H5.665z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ArchiveboxFilledSize16Glyph.displayName = 'ArchiveboxFilledSize16Glyph';
